// src/config/poetryLabels.js
//
// PA5: poetry-appropriate DISPLAY labels for the overview section, shared by the
// student reader (PackReaderPoetry -> LitOverviewSection), the admin editor
// (PackPoemOverviewTab -> LitOverviewEditor) and the admin Preview
// (LitSectionPreview labelOverrides). Keyed by the overview BLOCK keys, which are
// UNCHANGED (context/keyFacts/plot/structure/historicalContext) -- only the labels a
// human sees differ, so a poetry anthology overview never reads "Plot" / "Structure
// Diagram". Literature keeps its own defaults (these are only applied on poetry packs).
export const POETRY_OVERVIEW_LABELS = {
    context: 'Anthology Context',
    keyFacts: 'Key Exam Facts',
    plot: 'Anthology Map',
    structure: 'Exam / Comparison Strategy',
    historicalContext: 'Historical Context',
};
